module.exports = __webpack_public_path__ + "img/cubus_logo_v5.ffd9de2e.svg";